import { inject, Injectable } from '@angular/core';
import { JobStatus } from '../../../shared/models/generated/ziroModels';
import { ActivatedRoute } from '@angular/router';
import { PollingAbstractService } from '../../../shared/services/abstract/polling.abstract.service';

@Injectable()
export class RingCentralCallQueuesPollingContext extends PollingAbstractService<JobStatus> {
  private _route = inject(ActivatedRoute);

  baseUrl = `/services/microsoft/migrations/tenants/${this._route.snapshot.params['tenantId']}/exports/ring-central/${this._route.snapshot.params['id']}/call-queues/status`;
}
